import React from 'react';
import styled from 'styled-components'
import insta from '../../assets/insta.svg';
import LinkedIn from '../../assets/linkedin.svg';
import github from '../../assets/github.svg';
import codepen from '../../assets/codepen.svg';

export default function SocialIcons(){
    return(
        <React.Fragment>
            <Icon destination={"https://github.com/vinayak-singh5302"} image={github} alt={"Github"}/>
            <Icon destination={"https://www.linkedin.com/in/vinayak-singh-0038241a9/"} image={LinkedIn} alt={"LinkedIn"}/>
            <Icon destination={"https://www.instagram.com/vinayak.singh2441/" } image={insta} alt={"Instagram"}/>
            <Icon destination={"https://codepen.io/vinayaksingh121"} image={codepen} alt={"Codepen.io"}/>
        </React.Fragment>
    );
}


const Icon =({ destination, image, alt}) => <Social rel={'noreferrer'} href={destination} target={"_blank"}><img src={image} alt={alt}/></Social>

const Social = styled.a`
    display: flex;
    justify-content: center;
    align-items:center;
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;

    &:hover{
        background: #454545;
    }

    img{
        color: #fff;
        width: 30px;
        height: 30px;
    }
`;